import script from "./ResultsTableSpeaker.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsTableSpeaker.vue?vue&type=script&setup=true&lang=js"

import "./ResultsTableSpeaker.vue?vue&type=style&index=0&id=6ab2a9df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab2a9df"]])

export default __exports__